import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from "reactstrap";
import { Link } from "react-router-dom";
// import * as TBToolkit from "react-bootstrap-table2-toolkit";
// const ToolkitProvider = TBToolkit.default;
// const { Search } = TBToolkit;
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import { useQuery } from "@apollo/client";
import { GET_USERS } from "./inboxes.query";
import { GET_LOCATION } from "./location.query";

import AddWidget from "src/components/AddWidget/AddWidget";
import AddexpandRowWidget from "src/components/AddWidget/AddexpandRowWidget";
import ExpandRowRenderer from "./ExpandRowRenderer";
import EditWidget from "src/components/EditWidget/EditWidget";
import "./Widgets.scss";

const Widgets = () => {
  const [tableData, setTableData] = useState([]);
  const [modal, setModal] = useState(false);
  const [locationModel, setLocationModel] = useState(false);
  const [editWidgetModel, setEditWidgetModel] = useState(false);
  const [PassedUserId, setPassedUserId] = useState(null);
  const [Id, setId] = useState(0);
  const [searchText, setSearchText] = useState("");

  const columns = [
    {
      dataField: "Id",
      text: "Id",
      sort: true,
      headerStyle: {
        textAlign: "center",
        backgroundColor: "#f8f9fa",
      } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
    },
    {
      dataField: "PublicId",
      text: "Public Id",
      sort: true,
      headerStyle: {
        textAlign: "left",
        backgroundColor: "#f8f9fa",
      } as React.CSSProperties,
      style: { textAlign: "left" } as React.CSSProperties,
    },
    {
      dataField: "Name",
      text: "Name",
      sort: true,
      headerStyle: {
        textAlign: "left",
        backgroundColor: "#f8f9fa",
      } as React.CSSProperties,
      style: { textAlign: "left" } as React.CSSProperties,
    },
    {
      dataField: "WelcomeText",
      text: "Text",
      sort: true,
      headerStyle: {
        textAlign: "left",
        backgroundColor: "#f8f9fa",
      } as React.CSSProperties,
      style: { textAlign: "left" } as React.CSSProperties,
    },
    {
      dataField: "Brand",
      text: "Brand",
      sort: true,
      headerStyle: {
        textAlign: "left",
        backgroundColor: "#f8f9fa",
      } as React.CSSProperties,
      style: { textAlign: "left" } as React.CSSProperties,
    },
    {
      dataField: "menu",
      isDummyField: true,
      editable: false,
      text: "Action",
      headerStyle: {
        textAlign: "center",
        backgroundColor: "#f8f9fa",
      } as React.CSSProperties,
      style: { textAlign: "center" } as React.CSSProperties,
      formatter: (cellContent: any, user: any) => (
        <div className="d-flex justify-content-center">
          <UncontrolledDropdown>
            <DropdownToggle tag="button" className="btn btn-light btn-sm">
              <i className="uil uil-ellipsis-h"></i>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem onClick={() => handleEditClicked(user)}>
                <i className="mdi mdi-pencil font-size-16 text-success me-1"></i>
                Edit
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
      ),
    },
  ];

  const defaultSorted: [{ dataField: string; order: "asc" | "desc" }] = [
    {
      dataField: "Id",
      order: "desc",
    },
  ];
  const pageOptions = {
    sizePerPage: 10,
    totalSize: tableData.length,
    custom: true,
    firstPageText: "First",
    prePageText: "<",
    nextPageText: ">",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: (from: number, to: number, size: number) => {
      return (
        <span className="react-bootstrap-table-pagination-total">
          Showing {from} to {to} of {size} Results
        </span>
      );
    },
  };
  // const { SearchBar } = Search;

  const { data, refetch } = useQuery(GET_USERS, { fetchPolicy: "no-cache" });

  useEffect(() => {
    if (data && data.msgbox_Widget) {
      var tmpData = data.msgbox_Widget.map(function (item: {
        WidgetId: number;
        PublicId: string;
        Name: string;
        WelcomeText: string;
        WidgetBrand: { Name: string };
      }) {
        return {
          Id: item.WidgetId,
          PublicId: item.PublicId,
          Name: item.Name,
          WelcomeText: item.WelcomeText,
          Brand: item.WidgetBrand.Name,
        };
      });

      setTableData(tmpData);
    }
  }, [data]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value;
    setSearchText(text);

    if (data && data.msgbox_Widget) {
      const filteredData = data.msgbox_Widget
        .filter((item: any) => {
          const searchStr = text.toLowerCase();
          return (
            (item.Name || "").toLowerCase().includes(searchStr) ||
            (item.PublicId || "").toLowerCase().includes(searchStr) ||
            (item.WelcomeText || "").toLowerCase().includes(searchStr) ||
            (item.WidgetBrand?.Name || "").toLowerCase().includes(searchStr)
          );
        })
        .map((item: any) => ({
          Id: item.WidgetId,
          PublicId: item.PublicId,
          Name: item.Name,
          WelcomeText: item.WelcomeText,
          Brand: item.WidgetBrand?.Name,
        }));
      setTableData(filteredData);
    }
  };

  // Handle Add new widget
  const toggleAddWidgetModal = () => {
    setModal(!modal);
  };
  const handleUserClicks = () => {
    toggleAddWidgetModal();
  };

  // Handle Location Widget
  const toggleAddLocationWidget = () => {
    setLocationModel(!locationModel);
  };
  const handleLocationWidget = (row: any) => {
    setId(row.Id);
    toggleAddLocationWidget();
  };

  //Handle Edit Widget
  const toggleEditWidgetModel = () => {
    setEditWidgetModel(!editWidgetModel);
  };
  const handleEditClicked = (user: any) => {
    toggleEditWidgetModel();
    setPassedUserId(user.Id);
  };

  const refetchData = () => {
    refetch();
  };

  // Expand Row
  const { data: location_data, refetch: location_refetch } = useQuery(
    GET_LOCATION,
    { fetchPolicy: "no-cache" }
  );
  const expandRow = {
    renderer: (row: any) => {
      const data = location_data?.msgbox_WidgetLocations || [];
      const found = data.filter((w: any) => w.WidgetId === row.Id);

      return (
        <div>
          <ExpandRowRenderer
            found={found}
            row={row}
            handleLocationWidget={handleLocationWidget}
            onRefetch={location_refetch}
          />
        </div>
      );
    },
    showExpandColumn: true,
    expandColumnStyle: { width: "50px", textAlign: "center" },
    expandColumnRenderer: ({ expanded }: { expanded: boolean }) => {
      return (
        <div className="expand-icon">
          <i className={`uil ${expanded ? "uil-minus" : "uil-plus"}`}></i>
        </div>
      );
    },
    expandHeaderColumnRenderer: () => {
      return <span></span>;
    },
    expandByColumnOnly: true,
  };

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <h4 className="card-title">All Widgets</h4>
              </div>
            </Col>
            <Col md={6}>
              <div className="d-flex flex-wrap align-items-start justify-content-md-end mt-2 mt-md-0 gap-2 mb-3">
                <div>
                  <Link to="#" className="btn btn-light" onClick={refetchData}>
                    <i className="uil uil-refresh me-1"></i> Refresh
                  </Link>
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={handleUserClicks}
                  >
                    <i className="uil uil-plus me-1"></i> Add New
                  </button>
                </div>
              </div>
            </Col>
          </Row>
        </CardHeader>

        <CardBody>
          <div className="d-flex align-items-center">
            <div className="search-box me-2">
              <div className="position-relative">
                <Input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  value={searchText}
                  onChange={handleSearch}
                />
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>

          <PaginationProvider pagination={paginationFactory(pageOptions)}>
            {({ paginationProps, paginationTableProps }) => (
              <React.Fragment>
                <Row>
                  <Col xl="12">
                    <div className="table-responsive">
                      <BootstrapTable
                        bordered={false}
                        striped={false}
                        defaultSorted={defaultSorted}
                        classes="table align-middle table-nowrap"
                        headerWrapperClasses="thead-dark"
                        headerClasses="table-dark"
                        {...paginationTableProps}
                        keyField="Id"
                        columns={columns}
                        data={tableData}
                        expandRow={expandRow}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col className="inner-custom-pagination d-flex">
                    <div className="d-inline">
                      <SizePerPageDropdownStandalone {...paginationProps} />
                    </div>
                    <div className="text-md-right ms-auto">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>

      <AddexpandRowWidget
        WidgetId={Id}
        locationModel={locationModel}
        setLocationModel={setLocationModel}
        onRefetch={location_refetch}
      />

      <AddWidget modal={modal} setModal={setModal} onRefetch={refetchData} />
      <EditWidget
        editWidgetModel={editWidgetModel}
        setEditWidgetModel={setEditWidgetModel}
        PassedUserId={PassedUserId}
        onRefetch={refetchData}
      />
    </React.Fragment>
  );
};

export default Widgets;
